import React, { createContext, useContext, useReducer } from "react";

export const PRODUCTS = {
  "AL-1": {
    id: "AL-1",
    name: "Ceolmhar",
    price: 15,
    image: "/img/cd_cover.jpg",
    description:
      "Holly Geraghty and Jonathan Roche on concertina, harp and accordion. Fourteen tracks of new and old tunes.",
    trackCount: 14,
  },
  "AL-2": {
    id: "AL-2",
    name: "Musical Musings From Mayo",
    price: 15,
    image: "/img/mmfm.jpg",
    description:
      "Holly's solo harp album. Ten tracks of traditional tunes and her own compositions, from Ballindine to the Doolough Valley.",
    trackCount: 10,
    year: 2024,
  },
};

const CartContext = createContext();

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const existing = state.find((item) => item.id === action.payload.id);
      if (existing) {
        return state.map((item) =>
          item.id === action.payload.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...state, { ...action.payload, quantity: 1 }];
    }
    case "REMOVE_ITEM":
      return state.filter((item) => item.id !== action.payload);
    case "CLEAR_CART":
      return [];
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [items, dispatch] = useReducer(cartReducer, []);

  const addItem = (productId) => {
    const product = PRODUCTS[productId];
    if (product) {
      dispatch({ type: "ADD_ITEM", payload: product });
    }
  };

  const removeItem = (productId) => {
    dispatch({ type: "REMOVE_ITEM", payload: productId });
  };

  const clearCart = () => {
    dispatch({ type: "CLEAR_CART" });
  };

  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, clearCart, itemCount }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}

export default CartContext;
